import { CKEditor } from '@ckeditor/ckeditor5-react';
import CustomEditor from 'ckeditor5-custom-build/build/ckeditor';

function Ckeditor(props) {
    function uploadAdapter(loader) {
        return {
            upload: () => {
                return new Promise((resolve, reject) => {
                    const body = new FormData();
                    loader.file.then((file) => {
                        body.append('file', file);
                        fetch(
                            'https://api.kerbo.co.kr/upload/image?ai=' +
                                window.sessionStorage.getItem('aid') +
                                '&ac=' +
                                window.sessionStorage.getItem('authcode'),
                            {
                                method: 'post',
                                body: body,
                            }
                        )
                            .then((res) => res.json())
                            .then((data) => {
                                resolve({
                                    default: data['url'],
                                });
                            })
                            .catch((err) => {
                                reject(err);
                            });
                    });
                });
            },
        };
    }

    function uploadPlugin(editor) {
        editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
            return uploadAdapter(loader);
        };
    }

    return (
        <CKEditor
            editor={CustomEditor}
            data={props.content}
            config={{
                extraPlugins: [uploadPlugin],
                toolbar: {      
                    viewportTopOffset : props.viewportTopOffset,
                },
                mediaEmbed: {
                    previewsInData:true,
                },
            }}
            onChange={(event, editor) => {
                props.setContent(editor.getData());
            }}
        />
    );
}

export default Ckeditor;
